export const actionDaysMap = {
  last30Minutes: 0,
  last1Hour: 0,
  last2Hours: 0,
  last3Hours: 0,
  last6Hours: 0,
  last12Hours: 0,
  today: 1,
  yesterday: 1,
  last24Hours: 1,
  last2Days: 2,
  last3Days: 3,
  last7Days: 7,
  last30Days: 30,
  thisWeek: 7,
  thisMonth: 31,
  thisYear: 366,
  allTime: Infinity
};

export const getDateRangeFromAction = (action) => {
  const actions = {
    today: () => {
      const from = new Date();
      from.setHours(0, 0, 0, 0);
      const to = new Date();
      to.setHours(23, 59, 59, 999);
      return { from, to };
    },
    yesterday: () => {
      const from = new Date();
      from.setDate(from.getDate() - 1);
      from.setHours(0, 0, 0, 0);
      const to = new Date();
      to.setDate(to.getDate() - 1);
      to.setHours(23, 59, 59, 999);
      return { from, to };
    },
    last30Minutes: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 30 * 60 * 1000);
      return { from, to: now };
    },
    last1Hour: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 60 * 60 * 1000);
      return { from, to: now };
    },
    last2Hours: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 2 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last3Hours: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 3 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last6Hours: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 6 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last12Hours: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 12 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last24Hours: () => {
      const now = new Date(new Date().getTime() + 5 * 60 * 1000);
      const from = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last2Days: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last3Days: () => {
      const now = new Date();
      const from = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000);
      return { from, to: now };
    },
    last7Days: () => {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      return { from: date, to: new Date() };
    },
    last30Days: () => {
      const date = new Date();
      date.setDate(date.getDate() - 30);
      return { from: date, to: new Date() };
    },
    thisWeek: () => {
      const today = new Date();
      const firstDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
      const lastDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 6));
      return { from: firstDayOfWeek, to: lastDayOfWeek };
    },
    thisMonth: () => {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return { from: firstDayOfMonth, to: lastDayOfMonth };
    },
    last3Months: () => {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth() - 2, 1);
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return { from: firstDayOfMonth, to: lastDayOfMonth };
    },
    last6Months: () => {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth() - 5, 1);
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return { from: firstDayOfMonth, to: lastDayOfMonth };
    },
    thisYear: () => {
      const today = new Date();
      const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
      const lastDayOfYear = new Date(today.getFullYear(), 11, 31);
      return { from: firstDayOfYear, to: lastDayOfYear };
    },
    allTime: () => {
      return { from: null, to: null };
    }
  };

  return actions[action] ? actions[action]() : null;
};

export const getDateFromActionMap = () => {
  return {
    today: () => getDateRangeFromAction('today'),
    yesterday: () => getDateRangeFromAction('yesterday'),
    last30Minutes: () => getDateRangeFromAction('last30Minutes'),
    last1Hour: () => getDateRangeFromAction('last1Hour'),
    last2Hours: () => getDateRangeFromAction('last2Hours'),
    last3Hours: () => getDateRangeFromAction('last3Hours'),
    last6Hours: () => getDateRangeFromAction('last6Hours'),
    last12Hours: () => getDateRangeFromAction('last12Hours'),
    last24Hours: () => getDateRangeFromAction('last24Hours'),
    last2Days: () => getDateRangeFromAction('last2Days'),
    last3Days: () => getDateRangeFromAction('last3Days'),
    last7Days: () => getDateRangeFromAction('last7Days'),
    last30Days: () => getDateRangeFromAction('last30Days'),
    thisWeek: () => getDateRangeFromAction('thisWeek'),
    thisMonth: () => getDateRangeFromAction('thisMonth'),
    last3Months: () => getDateRangeFromAction('last3Months'),
    last6Months: () => getDateRangeFromAction('last6Months'),
    thisYear: () => getDateRangeFromAction('thisYear'),
    allTime: () => []
  };
};

export const getActionLabel = (action) => {
  const labels = {
    today: 'Today',
    yesterday: 'Yesterday',
    last30Minutes: 'Last 30 minutes',
    last1Hour: 'Last 1 hour',
    last2Hours: 'Last 2 hours',
    last3Hours: 'Last 3 hours',
    last6Hours: 'Last 6 hours',
    last12Hours: 'Last 12 hours',
    last24Hours: 'Last 24 hours',
    last2Days: 'Last 2 days',
    last3Days: 'Last 3 days',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisYear: 'This year',
    allTime: 'All time'
  };

  return labels[action] || 'Custom range';
};
